import { CalendarDays, LayoutGrid, Sparkles, UserRound } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

import styles from "./Footer.module.css";

type TabKey = "productos" | "reservas" | "fidelis" | "perfil";

const tabs: Array<{
  key: TabKey;
  label: string;
  route: string;
  icon: typeof LayoutGrid;
  matches: (pathname: string) => boolean;
}> = [
  {
    key: "productos",
    label: "Productos",
    route: "/product",
    icon: LayoutGrid,
    matches: (pathname) =>
      pathname === "/product" ||
      pathname.startsWith("/service-products") ||
      pathname.startsWith("/public-service") ||
      pathname.startsWith("/public-services")
  },
  {
    key: "reservas",
    label: "Reservas",
    route: "/calendar",
    icon: CalendarDays,
    matches: (pathname) => pathname === "/calendar" || pathname.startsWith("/recurrent-bookings")
  },
  {
    key: "fidelis",
    label: "Fidelis Score",
    route: "/statistics",
    icon: Sparkles,
    matches: (pathname) => pathname === "/statistics"
  },
  {
    key: "perfil",
    label: "Perfil",
    route: "/user",
    icon: UserRound,
    matches: (pathname) =>
      pathname === "/user" ||
      pathname.startsWith("/profile") ||
      pathname.startsWith("/settings") ||
      pathname.startsWith("/documents") ||
      pathname.startsWith("/notifications") ||
      pathname.startsWith("/payment-methods") ||
      pathname.startsWith("/favorites") ||
      pathname.startsWith("/add-coupons") ||
      pathname.startsWith("/ewallet")
  }
];

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className={styles.footerWrapper}>
      <footer className={styles.footer}>
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = tab.matches(location.pathname);

          return (
            <button
              key={tab.key}
              type="button"
              className={`${styles.tab} ${isActive ? styles.active : ""}`}
              onClick={() => navigate(tab.route)}
              data-tour={`tab-${tab.key}`}
            >
              <span className={styles.iconWrap}>
                <Icon size={20} strokeWidth={isActive ? 2.35 : 2.1} />
              </span>
              <span className={styles.label}>{tab.label}</span>
            </button>
          );
        })}
      </footer>
    </div>
  );
}
